import LBMGraficoExtraRelatorio from "entity/Indicador/LBM/components/LBMGraficoExtraRelatorio";
import LCGraficoExtraRelatorio from "entity/Indicador/LC/components/LCGraficoExtraRelatorio";
import PerdasGraficoExtraRelatorio from "entity/Indicador/Perdas/components/PerdasGraficoExtraRelatorio";

export default function GraficosExtraRelatorio(content, h, mediaAgrupadorList, meta, IndicadorEntity, groupByConfig, apontamentos, paramsCliente, dataInicio, dataFim, field) {
    switch (field) {
        case 'lbm':
            return LBMGraficoExtraRelatorio(content, h, mediaAgrupadorList, meta, IndicadorEntity, groupByConfig, apontamentos, paramsCliente, dataInicio, dataFim)
        case 'lc':
            return LCGraficoExtraRelatorio(content, h, mediaAgrupadorList, meta, IndicadorEntity, groupByConfig, apontamentos, paramsCliente, dataInicio, dataFim)
        case 'perd':
            return PerdasGraficoExtraRelatorio(content, h, mediaAgrupadorList, meta, IndicadorEntity, groupByConfig, apontamentos, paramsCliente, dataInicio, dataFim)
        default:
        // console.log(`${IndicadorEntity.fullName} não possui gráfico secundário`)
    }
}